'use client'

import DownloadQrModal from '@/components/DownloadQrModal'
import LanguageSwitcher from '@/components/buttons/LanguageSwitcher'
import MainButton from '@/components/buttons/MainButton'
import { gapping, padding } from '@/components/spacing'
import Typography from '@/components/typography/Typography'
import { useT } from '@/phrase/hooks/useT'
import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'
import React, { Dispatch, useEffect, useRef, useState } from 'react'

const navItems = [
  // {
  //   name: 'navbar_solutions',
  //   href: 'https://blog.freedom.world/feature-the-scape',
  //   subChild: {
  //     name: 'nav_businesses_title',
  //     href: 'https://blog.freedom.world/build-your-community',
  //   },
  //   children: [
  //     {
  //       name: 'nav_solutions_acquire_customers_title',
  //       href: 'https://blog.freedom.world/build-your-community/small-business',
  //     },
  //     {
  //       name: 'navbar_solutions_events',
  //       href: 'https://blog.freedom.world/build-your-community/events',
  //     },
  //     {
  //       name: 'navbar_solutions_contentcreators',
  //       href: 'https://blog.freedom.world/build-your-community/content-creators',
  //     },
  //     {
  //       name: 'navbar_solutions_education',
  //       href: 'https://blog.freedom.world/build-your-community/education',
  //     },
  //     {
  //       name: 'navbar_solutions_sharedinterest',
  //       href: 'https://blog.freedom.world/build-your-community/shared-interest',
  //     },
  //     {
  //       name: 'navbar_solutions_fandom',
  //       href: 'https://blog.freedom.world/build-your-community/fandom',
  //     },
  //   ],
  // },
  // {
  //   name: 'navbar_products',
  //   children: [
  //     {
  //       name: 'Merchant',
  //       href: 'https://blog.freedom.world/feature-the-scape',
  //     },
  //     {
  //       name: 'Moderation',
  //       href: '',
  //     },
  //     {
  //       name: 'Communities',
  //       href: '',
  //     },
  //     {
  //       name: 'CRM',
  //       href: '',
  //     },
  //     {
  //       name: 'Loyalty',
  //       href: '',
  //     },
  //     {
  //       name: 'Operations',
  //       href: '',
  //     },
  //     {
  //       name: 'Social',
  //       href: '',
  //     },
  //     {
  //       name: 'Chat',
  //       href: '',
  //     },
  //     {
  //       name: 'Referrals',
  //       href: '',
  //     },
  //     {
  //       name: 'Notifications',
  //       href: '',
  //     },
  //     {
  //       name: 'Map',
  //       href: '',
  //     },
  //     {
  //       name: 'Games',
  //       href: '',
  //     },
  //     {
  //       name: 'Shop',
  //       href: '',
  //     },
  //     {
  //       name: 'Payment',
  //       href: '',
  //     },
  //     {
  //       name: 'Analytics',
  //       href: '',
  //     },
  //     {
  //       name: 'Wallet',
  //       href: '',
  //     },
  //     {
  //       name: 'Revenue',
  //       href: '',
  //     },
  //     {
  //       name: 'AI',
  //       href: '',
  //     },
  //   ],
  // },
  {
    name: 'navbar_ecosystem',
    children: [
      {
        name: 'FDM',
        href: 'https://freedom.world/fdm',
      },
      {
        name: 'navbar_desktop_ecosystem_freedomcard',
        href: 'https://freedom.world/freedomcard',
      },
    ],
  },
  {
    name: 'navbar_resources',
    href: 'https://blog.freedom.world/resource-hub',
  },
  // {
  //   name: 'navbar_company',
  //   href: 'https://info.freedom.world/vision',
  // },
]

const MANAGE_PRODUCTS = [
  { label: 'nav_manage_merchant_title', desc: 'nav_manage_merchant_desc', url: 'https://freedom.world/products/manage#merchant', icon: '/svgs/solar_shop-bold.svg' },
  { label: 'nav_manage_moderation_title', desc: 'nav_manage_moderation_desc', url: 'https://freedom.world/products/manage#moderation', icon: '/svgs/material-symbols_manage-search.svg' },
  { label: 'nav_manage_communities_title', desc: 'nav_manage_communities_desc', url: 'https://freedom.world/products/manage#communities', icon: '/svgs/fluent_people-community-12-filled.svg' },
  { label: 'nav_manage_crm_title', desc: 'nav_manage_crm_desc', url: 'https://freedom.world/products/manage#crm', icon: '/svgs/icon_people.svg' },
  { label: 'nav_manage_loyalty_title', desc: 'nav_manage_loyalty_desc', url: 'https://freedom.world/products/manage#loyalty', icon: '/svgs/streamline_star-badge-solid.svg' },
  { label: 'nav_manage_operations_title', desc: 'navbar_desktop_solutions_contentcreators', url: 'https://freedom.world/products/manage#operations', icon: '/svgs/lsicon_operation-filled.svg' },
]

const ENGAGE_PRODUCTS = [
  { label: 'nav_engage_social_title', desc: 'nav_engage_social_desc', url: 'https://freedom.world/products/engage#social', icon: '/svgs/fluent_people-community-12-filled.svg' },
  { label: 'nav_engage_chat_title', desc: 'nav_engage_chat_desc', url: 'https://freedom.world/products/engage#chat', icon: '/svgs/fluent_chat-12-filled.svg' },
  { label: 'nav_engage_referrals_title', desc: 'nav_engage_referrals_desc', url: 'https://freedom.world/products/engage#referrals', icon: '/svgs/icon-park-solid_circular-connection.svg' },
  { label: 'nav_engage_notifications_title', desc: 'nav_engage_notifications_desc', url: 'https://freedom.world/products/engage#notifications', icon: '/svgs/mingcute_notification-fill.svg' },
  { label: 'nav_engage_map_title', desc: 'nav_engage_map_desc', url: 'https://freedom.world/products/engage#map', icon: '/svgs/solar_map-bold.svg' },
  { label: 'nav_engage_games_title', desc: 'nav_engage_games_desc', url: 'https://freedom.world/products/engage#games', icon: '/svgs/mynaui_controller-solid.svg' },
]

const MONETIZE_PRODUCTS = [
  { label: 'nav_monetize_shop_title', desc: 'nav_monetize_shop_desc', url: 'https://freedom.world/products/monetize#shop', icon: '/svgs/solar_shop-bold.svg' },
  { label: 'nav_monetize_payment_title', desc: 'nav_monetize_payment_desc', url: 'https://freedom.world/products/monetize#payment', icon: '/svgs/solar_dollar-bold.svg' },
  { label: 'nav_monetize_analytics_title', desc: 'nav_monetize_analytics_desc', url: 'https://freedom.world/products/monetize#analytics', icon: '/svgs/ix_analyze.svg' },
  { label: 'nav_monetize_wallet_title', desc: 'nav_monetize_wallet_desc', url: 'https://freedom.world/products/monetize#wallet', icon: '/svgs/mingcute_wallet-fill.svg' },
  { label: 'nav_monetize_revenue_title', desc: 'nav_monetize_revenue_desc', url: 'https://freedom.world/products/monetize#revenue', icon: '/svgs/streamline-flex_decent-work-and-economic-growth-solid.svg' },
  { label: 'nav_monetize_ai_title', desc: 'nav_monetize_ai_desc', url: 'https://freedom.world/products/monetize#ai', icon: '/svgs/mingcute_ai-fill.svg' },
]

const DesktopNavItemHoverIntent = ({
  item,
  t,
}: {
  item: {
    name: string
    subChild?: { name: string; href: string }
    children?: { name: string; href: string }[]
  }
  t: (key: string) => string
}) => {
  const [open, setOpen] = useState(false)
  const closeTimer = useRef<ReturnType<typeof setTimeout> | null>(null)

  const openNow = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current)
    setOpen(true)
  }

  const closeSoon = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current)
    closeTimer.current = setTimeout(() => setOpen(false), 180)
  }

  const isMegaMenu =
    item.name === 'navbar_solutions' ||
    item.name === 'navbar_products' ||
    item.name === 'navbar_ecosystem'

  const ecosystemCards = [
    {
      title: t('nav_scape_title'),
      desc: t('nav_scape_desc'),
      href: 'https://blog.freedom.world/feature-the-scape',
      imageSrc: '/images/home/ecosystem/Visual_Ecosystem_01.webp',
      badge: undefined as string | undefined,
    },
    {
      title: t('nav_fdm_title'),
      desc: t('nav_fdm_desc'),
      href: 'https://freedom.world/fdm',
      imageSrc: '/images/home/ecosystem/Visual_Ecosystem_02.webp',
      badge: undefined as string | undefined,
    },
    {
      title: t('nav_fds_title'),
      desc: t('nav_fds_desc'),
      href: 'https://blog.freedom.world/blog/freedom-shards',
      imageSrc: '/images/home/ecosystem/Visual_Ecosystem_03.webp',
      badge: undefined as string | undefined,
    },
    {
      title: t('nav_fdc_title'),
      desc: t('nav_fdc_desc'),
      href: 'https://freedom.world/freedomcard',
      imageSrc: '/images/home/ecosystem/Visual_Ecosystem_04.webp',
      badge: undefined as string | undefined,
    },
    {
      title: t('nav_planets_title'),
      desc: t('nav_planets_desc'),
      href: 'https://blog.freedom.world/planets',
      imageSrc: '/images/home/ecosystem/Visual_Ecosystem_06.webp',
      badge: 'NEW',
    },
    // {
    //   title: t('nav_arcade_title'),
    //   desc: t('nav_arcade_desc'),
    //   href: 'https://freedom.world/',
    //   imageSrc: '/images/home/ecosystem/Visual_Ecosystem_05.webp',
    //   badge: 'NEW',
    // },
  ]

  return (
    <div
      className="relative"
      onMouseEnter={openNow}
      onMouseLeave={closeSoon}
      onFocus={openNow}
      onBlur={closeSoon}
    >
      <div className="absolute -right-2 top-3.25">
        {open ? (
          <Image src="/svgs/Chevron-Down.svg" width={20} height={20} alt="" />
        ) : (
          <Image
            src="/svgs/Chevron-Down-White.svg"
            width={20}
            height={20}
            alt=""
          />
        )}
      </div>

      <div className="flex flex-col">
        <div
          className={clsx(
            'hover:cursor-pointer text-white/90 whitespace-nowrap text-xs font-bold uppercase',
            open ? 'text-green-main' : '',
            padding('Button/Spacing/left-right'),
            padding('Button/Spacing/top-bot'),
          )}
        >
          <Typography
            variant="buttonSmall"
            type="span"
            weight="400"
            className={clsx('w-fit', open ? 'text-green-main' : 'text-white')}
          >
            {t(item.name)}
          </Typography>
        </div>

        {/* Dropdown */}
        <div
          className={clsx(
            isMegaMenu
              ? 'fixed left-0 right-0 top-27.25 z-50'
              : 'absolute left-0 top-full z-50',
            open
              ? 'opacity-100 pointer-events-auto translate-y-0'
              : 'opacity-0 pointer-events-none -translate-y-1',
            'transition-all',
          )}
        >
          {isMegaMenu ? (
            <div className="w-full max-w-[100vw] overflow-x-hidden px-0">
              <div className="w-full bg-[#1248BE] shadow-lg">
                {item.name === 'navbar_ecosystem' ? (
                  <div className="w-full py-8">
                    <div className="overflow-x-auto overflow-y-hidden overscroll-x-contain [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
                      <div className="flex flex-col w-max gap-6 pl-6 pr-6 md:pl-10 md:pr-10 mx-auto">
                        <div className="flex gap-1 hover:gap-4 transition-all duration-150 cursor-pointer">
                          <p className="text-xl font-black uppercase text-white">
                            {t('navbar_ecosystem')}
                          </p>
                          {/* <Image
                            src="/svgs/Arrow-Right-Narrow.svg"
                            width={24}
                            height={24}
                            alt=""
                          /> */}
                        </div>
                        
                        <div className="flex gap-4 md:gap-6">
                          {ecosystemCards.map((card) => (
                            <a
                              key={card.title}
                              href={card.href}
                              target="_blank"
                              rel="noreferrer"
                              className="group w-60 md:w-65 shrink-0"
                            >
                              <div className="relative h-36.5 w-full overflow-hidden rounded-2xl bg-white/10">
                                <Image
                                  src={card.imageSrc}
                                  alt=""
                                  fill
                                  sizes="260px"
                                  className="object-cover"
                                />
                              </div>

                              <div className="mt-3 flex items-center gap-2">
                                <p className="text-sm font-black uppercase text-white group-hover:text-green-main">
                                  {card.title}
                                </p>
                                {card.badge ? (
                                  <span className="rounded-md bg-[#0E3285] px-2 py-0.5 text-[10px] font-black uppercase text-green-main">
                                    {card.badge}
                                  </span>
                                ) : null}
                              </div>

                              <p className="mt-2 text-xs leading-[150%] text-white/80">
                                {card.desc}
                              </p>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="mx-auto max-w-360 px-10 py-8">
                    {item.name === 'navbar_products' ? (
                      <div>
                        <div className="grid grid-cols-1 gap-4">
                          {/* MANAGE Section */}
                          <div className="flex flex-col gap-4">
                            <div>
                              <div className="flex gap-1 hover:gap-4 transition-all duration-150 cursor-pointer" onClick={()=>window.open("https://freedom.world/products/manage", '_blank')}>
                                <p className="text-xl font-black uppercase text-light-gray">
                                  {t("nav_manage_title")}
                                </p>
                                <Image
                                  src="/svgs/Arrow-Right-Narrow.svg"
                                  width={24}
                                  height={24}
                                  alt=""
                                />
                              </div>
                            </div>
                            <div className="grid grid-cols-3 gap-2">
                              {MANAGE_PRODUCTS.map((x) => (
                                <div className="flex rounded-xl hover:bg-[#161B85] p-2 cursor-pointer" key={x.label} onClick={() => window.open(x.url, '_blank')}>
                                  <Image
                                    src={x.icon}
                                    width={24}
                                    height={24}
                                    alt=""
                                  />
                                  <button
                                    type="button"
                                    className="group flex w-full flex-col items-start gap-1  px-3 py-2 text-left cursor-pointer "
                                  >
                                    <span className="text-sm font-semibold text-white">
                                      {t(x.label)}
                                    </span>
                                    <span className="text-xs text-white/80">
                                      {t(x.desc)}
                                    </span>
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>

                          {/* ENGAGE Section */}
                          <div className="flex flex-col gap-4">
                            <div>
                              <div className="flex gap-1 hover:gap-4 transition-all duration-150 cursor-pointer" onClick={()=> window.open('https://freedom.world/products/engage', '_blank')}>
                                <p className="text-xl font-black uppercase text-light-gray">
                                  {t("products_engage_title")}
                                </p>
                                <Image
                                  src="/svgs/Arrow-Right-Narrow.svg"
                                  width={24}
                                  height={24}
                                  alt=""
                                />
                              </div>
                            </div>
                            <div className="grid grid-cols-3 gap-3">
                              {ENGAGE_PRODUCTS.map((x) => (
                                <div className="flex rounded-xl hover:bg-[#161B85] p-2 cursor-pointer" key={x.label} onClick={() => window.open(x.url, '_blank')}>
                                  <Image
                                    src={x.icon}
                                    width={24}
                                    height={24}
                                    alt=""
                                  />
                                  <button
                                    type="button"
                                    className="group flex w-full flex-col items-start gap-1 px-3 py-2 text-left cursor-pointer"
                                  >
                                    <span className="text-sm font-semibold text-white">
                                      {t(x.label)}
                                    </span>
                                    <span className="text-xs text-white/80">
                                      {t(x.desc)}
                                    </span>
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>

                          {/* MONETIZE Section */}
                          <div className="flex flex-col gap-4">
                            <div onClick={()=> window.open('https://freedom.world/products/monetize', '_blank')}>
                              <div className="flex gap-1 hover:gap-4 transition-all duration-150 cursor-pointer">
                                <p className="text-xl font-black uppercase text-light-gray">
                                  {t('products_monetize_title')}
                                </p>
                                <Image
                                  src="/svgs/Arrow-Right-Narrow.svg"
                                  width={24}
                                  height={24}
                                  alt=""
                                />
                              </div>
                            </div>
                            <div className="grid grid-cols-3 gap-3">
                              {MONETIZE_PRODUCTS.map((x) => (
                                <div className="flex rounded-xl hover:bg-[#161B85] p-2 cursor-pointer" key={x.label} onClick={() => window.open(x.url, '_blank')}>
                                  <Image
                                    src={x.icon}
                                    width={24}
                                    height={24}
                                    alt=""
                                  />
                                  <button
                                    type="button"
                                    className="group flex w-full flex-col items-start gap-1 px-3 py-2 text-left cursor-pointer"
                                  >
                                    <span className="text-sm font-semibold text-white">
                                      {t(x.label)}
                                    </span>
                                    <span className="text-xs text-white/80">
                                      {t(x.desc)}
                                    </span>
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="grid grid-cols-3 gap-10">
                        {/* Column 1 */}
                        <div className="flex flex-col gap-4">
                          <div>
                            <div onClick={() => window.open('https://freedom.world/solutions/for-businesses', '_blank')} className="flex gap-1 hover:gap-4 transition-all duration-150 cursor-pointer">
                              <p className="text-xl font-black uppercase text-light-gray">
                                {t('nav_businesses_title')}
                              </p>
                              <Image
                                src="/svgs/Arrow-Right-Narrow.svg"
                                width={24}
                                height={24}
                                alt=""
                              />
                            </div>
                            <p className="text-xs text-light-gray2">
                              {t('nav_businesses_desc')}
                            </p>
                          </div>
                          <div className="flex flex-col gap-3">
                            {[
                              {
                                label: t(
                                  'nav_solutions_acquire_customers_title',
                                ),
                                desc: t('nav_solutions_acquire_customers_desc'),
                                icon: '/svgs/icon_people.svg',
                              },
                              {
                                label: t('nav_solutions_build_loyalty_title'),
                                desc: t('nav_solutions_build_loyalty_desc'),
                                icon: '/svgs/icon_starbadge.svg',
                              },
                              {
                                label: t(
                                  'nav_solutions_engage_community_title',
                                ),
                                desc: t('nav_solutions_engage_community_desc'),
                                icon: '/svgs/icon_community.svg',
                              },
                              {
                                label: t('nav_solutions_sell_monetize_title'),
                                desc: t('nav_solutions_sell_monetize_desc'),
                                icon: '/svgs/icon_dollar.svg',
                              },
                              {
                                label: t(
                                  'nav_solutions_understand_customers_title',
                                ),
                                desc: t(
                                  'nav_solutions_understand_customers_desc',
                                ),
                                icon: '/svgs/icon_analyze.svg',
                              },
                            ].map((x) => (
                              <div className="flex rounded-xl hover:bg-[#161B85] p-2" key={x.label}>
                                <Image
                                  src={x.icon}
                                  width={24}
                                  height={24}
                                  alt=""
                                />
                                <button
                                  type="button"
                                  className="group flex w-full flex-col items-start gap-1  px-3 py-2 text-left"
                                >
                                  <span className="text-sm font-semibold text-white">
                                    {x.label}
                                  </span>
                                  <span className="text-xs text-white/80">
                                    {x.desc}
                                  </span>
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Column 2 */}
                        <div className="flex flex-col gap-4">
                          <div>
                            <div onClick={() => window.open('https://freedom.world/solutions/for-creators', '_blank')} className="flex gap-1 hover:gap-4 transition-all duration-150 cursor-pointer">
                              <p className="text-xl font-black uppercase text-light-gray">
                                {t('nav_creators_title')}
                              </p>
                              <Image
                                src="/svgs/Arrow-Right-Narrow.svg"
                                width={24}
                                height={24}
                                alt=""
                              />
                            </div>
                            <p className="text-xs text-light-gray2">
                              {t('nav_creators_desc')}
                            </p>
                          </div>
                          <div className="flex flex-col gap-3">
                            {[
                              {
                                label: t('nav_solutions_own_audience_title'),
                                desc: t('nav_solutions_own_audience_desc'),
                                icon: '/svgs/icon_heartmessage.svg',
                              },
                              {
                                label: t(
                                  'nav_solutions_monetize_content_title',
                                ),
                                desc: t('nav_solutions_monetize_content_desc'),
                                icon: '/svgs/icon_analyze.svg',
                              },
                              {
                                label: t('nav_solutions_engage_fans_title'),
                                desc: t('nav_solutions_engage_fans_desc'),
                                icon: '/svgs/icon_starbadge.svg',
                              },
                              {
                                label: t(
                                  'nav_solutions_distribute_content_title',
                                ),
                                desc: t(
                                  'nav_solutions_distribute_content_desc',
                                ),
                                icon: '/svgs/icon_dollar.svg',
                              },
                              {
                                label: t('nav_solutions_track_growth_title'),
                                desc: t('nav_solutions_track_growth_desc'),
                                icon: '/svgs/icon_people.svg',
                              },
                            ].map((x) => (
                              <div className="flex rounded-xl hover:bg-[#161B85] p-2" key={x.label}>
                                <Image
                                  src={x.icon}
                                  width={24}
                                  height={24}
                                  alt=""
                                />
                                <button
                                  type="button"
                                  className="group flex w-full flex-col items-start gap-1 px-3 py-2 text-left"
                                >
                                  <span className="text-sm font-semibold text-white">
                                    {x.label}
                                  </span>
                                  <span className="text-xs text-white/80">
                                    {x.desc}
                                  </span>
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* Column 3 */}
                        <div className="flex flex-col gap-4">
                          <div>
                            <div onClick={() => window.open('https://freedom.world/solutions/for-users', '_blank')} className="flex gap-1 hover:gap-4 transition-all duration-150 cursor-pointer">
                              <p className="text-xl font-black uppercase text-light-gray">
                                {t('nav_users_title')}
                              </p>
                              <Image
                                src="/svgs/Arrow-Right-Narrow.svg"
                                width={24}
                                height={24}
                                alt=""
                              />
                            </div>
                            <p className="text-xs text-light-gray2">
                              {t('nav_users_desc')}
                            </p>
                          </div>

                          <div className="flex flex-col gap-3">
                            {[
                              {
                                label: t(
                                  'nav_solutions_discover_experience_title',
                                ),
                                desc: t(
                                  'nav_solutions_discover_experience_desc',
                                ),
                                icon: '/svgs/icon_compass.svg',
                              },
                              {
                                label: t('nav_solutions_connect_belong_title'),
                                desc: t('nav_solutions_connect_belong_desc'),
                                icon: '/svgs/icon_community.svg',
                              },{
                                label: t(
                                  'nav_solutions_explore_and_play_title',
                                ),
                                desc: t('nav_solutions_explore_and_play_desc'),
                                icon: '/svgs/icon_game.svg',
                              },
                              {
                                label: t(
                                  'nav_solutions_collect_manage_rewards_title',
                                ),
                                desc: t(
                                  'nav_solutions_collect_manage_rewards_desc',
                                ),
                                icon: '/svgs/mingcute_wallet-fill.svg',
                              },
                              {
                                label: t(
                                  'nav_solutions_express_identity_title',
                                ),
                                desc: t('nav_solutions_express_identity_desc'),
                                icon: '/svgs/icon_fingerprint.svg',
                              },
                              // {
                              //   label: t(
                              //     'nav_solutions_earn_and_progress_title',
                              //   ),
                              //   desc: t('nav_solutions_earn_and_progress_desc'),
                              //   icon: '/svgs/mingcute_wallet-fill.svg',
                              // },
                              
                              
                            ].map((x) => (
                              <div className="flex rounded-xl hover:bg-[#161B85] p-2" key={x.label}>
                                <Image
                                  src={x.icon}
                                  width={24}
                                  height={24}
                                  alt=""
                                />
                                <button
                                  type="button"
                                  className="group flex w-full flex-col items-start gap-1 px-3 py-2 text-left"
                                >
                                  <span className="text-sm font-semibold text-white">
                                    {x.label}
                                  </span>
                                  <span className="text-xs text-white/80">
                                    {x.desc}
                                  </span>
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div
              className={clsx(
                'rounded-b-2xl bg-main-bg mt-8 shadow-lg px-4 py-4 pt-6 min-w-65',
              )}
            >
              {item.subChild && (
                <button
                  onClick={() => window.open(item.subChild!.href, '_blank')}
                  className="relative group/button w-full flex items-center justify-between px-10 py-2 pb-4 font-bold uppercase  text-18 text-white hover:text-green-main whitespace-nowrap"
                >
                  <span>{t(item.subChild.name)}</span>
                  <Image
                    src="/svgs/Chevron-Right.svg"
                    width={16}
                    height={16}
                    alt=""
                    className="opacity-0 absolute transition-opacity group-hover/button:opacity-100 right-0"
                  />
                </button>
              )}

              {item.children?.map((sub) => (
                <button
                  disabled={sub.href === '' ? true : false}
                  key={sub.name}
                  onClick={() => window.open(sub.href, '_blank')}
                  className="hover:cursor-pointer relative group/button w-full flex items-center justify-between px-10 py-2 pb-4 font-bold uppercase  text-sm text-white hover:text-green-main whitespace-nowrap disabled:text-white/50"
                >
                  <span>{t(sub.name)}</span>
                  {sub.href !== '' && (
                    <Image
                      src="/svgs/Chevron-Right.svg"
                      width={16}
                      height={16}
                      alt=""
                      className="opacity-0 transition-opacity group-hover/button:opacity-100 absolute right-0"
                    />
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const RenderHamburger = ({
  isOpen,
  setIsOpen,
  menuRef,
}: {
  isOpen: boolean
  setIsOpen: Dispatch<boolean>
  menuRef: React.RefObject<HTMLDivElement | null>
}) => {
  const t = useT()
  const [activeSubmenu, setActiveSubmenu] = useState<string | null>(null)
  const [openAccordions, setOpenAccordions] = useState<Record<string, boolean>>({})

  const handleDownloadClick = () => {
    const userAgent = navigator.userAgent || navigator.vendor
    
    // Detect iOS
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.open('https://apps.apple.com/my/app/freedom-world-social-chat/id1606936073', '_blank')
    }
    // Detect Android
    else if (/android/i.test(userAgent)) {
      window.open('https://play.google.com/store/apps/details?id=com.bitazza.freedom.wallet&hl=en', '_blank')
    }
    // Default to App Store for desktop/unknown
    else {
      window.open('https://apps.apple.com/my/app/freedom-world-social-chat/id1606936073', '_blank')
    }
    
    setIsOpen(false)
  }

  const handleBack = () => {
    setActiveSubmenu(null)
    setOpenAccordions({})
  }

  const toggleAccordion = (key: string) => {
    setOpenAccordions((prev) => {
      const isCurrentlyOpen = prev[key]
      // Close all accordions and toggle the clicked one
      return { [key]: !isCurrentlyOpen }
    })
  }

  const isMegaMenu = (name: string) => 
    name === 'navbar_solutions' || 
    name === 'navbar_products' || 
    name === 'navbar_ecosystem'

  const ecosystemCards = [
    {
      title: t('nav_scape_title'),
      desc: t('nav_scape_desc'),
      href: 'https://blog.freedom.world/feature-the-scape',
      imageSrc: '/images/home/ecosystem/Visual_Ecosystem_01.webp',
      badge: undefined as string | undefined,
    },
    {
      title: t('nav_fdm_title'),
      desc: t('nav_fdm_desc'),
      href: 'https://freedom.world/fdm',
      imageSrc: '/images/home/ecosystem/Visual_Ecosystem_02.webp',
      badge: undefined as string | undefined,
    },
    {
      title: t('nav_fds_title'),
      desc: t('nav_fds_desc'),
      href: 'https://blog.freedom.world/blog/freedom-shards',
      imageSrc: '/images/home/ecosystem/Visual_Ecosystem_03.webp',
      badge: undefined as string | undefined,
    },
    {
      title: t('nav_fdc_title'),
      desc: t('nav_fdc_desc'),
      href: 'https://freedom.world/freedomcard',
      imageSrc: '/images/home/ecosystem/Visual_Ecosystem_04.webp',
      badge: undefined as string | undefined,
    },
    {
      title: t('nav_planets_title'),
      desc: t('nav_planets_desc'),
      href: 'https://blog.freedom.world/planets',
      imageSrc: '/images/home/ecosystem/Visual_Ecosystem_05.webp',
      badge: 'NEW',
    },
    // {
    //   title: t('nav_arcade_title'),
    //   desc: t('nav_arcade_desc'),
    //   href: 'https://freedom.world/',
    //   imageSrc: '/images/home/ecosystem/Visual_Ecosystem_06.webp',
    //   badge: 'NEW',
    // },
  ]

  return (
    <div
      ref={menuRef}
      className={`
      fixed top-26.25 left-0 right-0 bottom-0 z-50 
      transition-all duration-300 ease-in-out 
      ${
        isOpen
          ? 'opacity-100 visible'
          : 'opacity-0 invisible'
      }
    `}
      style={{
        background: '#1248BE',
      }}
    >
      <div className="h-full flex flex-col overflow-y-auto">
        {/* Header with logo/back button and close button */}
        <div className="flex items-center justify-between px-6 py-6 shrink-0">
          {activeSubmenu ? (
            <button
              onClick={handleBack}
              className="flex items-center gap-2 text-white"
            >
             <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">
  <path d="M3.73816 7.41675L0.994077 4.67267C0.66864 4.34723 0.668641 3.8196 0.994078 3.49416L3.73816 0.750082M1.23816 4.08341L12.9048 4.08341" stroke="#F4F4FC" strokeWidth="1.5" strokeLinecap="round"/>
</svg>
              <span className="text-sm font-bold uppercase">{t("nav_solutions_back")}</span>
            </button>
          ) : (
            null
          )}
          {/* <button
            type="button"
            onClick={() => setIsOpen(false)}
            aria-label="Close menu"
            className="p-2"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button> */}
        </div>

        {/* Menu content */}
        <div className="flex flex-col flex-1 overflow-hidden relative">
          {/* Main menu */}
          <div className={clsx(
            'flex flex-col px-6 pb-6 absolute inset-0 overflow-y-auto transition-transform duration-300 ease-in-out',
            gapping('Navigation Bar/Spacing/space-between-buttons'),
            activeSubmenu ? '-translate-x-full' : 'translate-x-0'
          )}>
              {navItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => {
                    if (isMegaMenu(item.name)) {
                      setActiveSubmenu(item.name)
                    } else if (item.href) {
                      setIsOpen(false)
                      window.open(item.href, '_blank')
                    }
                  }}
                  className="hover:cursor-pointer w-full flex items-center justify-between text-left text-white/90 hover:text-green-main text-xl font-black uppercase py-2"
                >
                  <span>{t(item.name)}</span>
                  {isMegaMenu(item.name) && (
                    <Image
                      src="/svgs/Chevron-Right-White.svg"
                      width={20}
                      height={20}
                      alt=""
                    />
                  )}
                </button>
              ))}
            </div>
          
          {/* Ecosystem submenu */}
          <div className={clsx(
            'px-6 pb-6 absolute inset-0 overflow-y-auto transition-transform duration-300 ease-in-out',
            activeSubmenu === 'navbar_ecosystem' ? 'translate-x-0' : 'translate-x-full'
          )}>
              <p className="text-xl font-black uppercase text-white mb-6">ECOSYSTEM</p>
              <div className="flex flex-col gap-4">
                {ecosystemCards.map((card) => (
                  <button
                    key={card.title}
                    onClick={() => {
                      setIsOpen(false)
                      window.open(card.href, '_blank')
                    }}
                    className="text-left flex items-start justify-between gap-3"
                  >
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <p className="text-sm font-black uppercase text-white">
                          {card.title}
                        </p>
                        {card.badge && (
                          <span className="rounded-md bg-[#0E3285] px-2 py-0.5 text-[10px] font-black uppercase text-green-main">
                            {card.badge}
                          </span>
                        )}
                      </div>
                      <p className="text-xs leading-[150%] text-white/80">
                        {card.desc}
                      </p>
                    </div>
                    <Image
                      src="/svgs/Arrow-Right-Narrow.svg"
                      width={24}
                      height={24}
                      alt=""
                      className="shrink-0 mt-1"
                    />
                  </button>
                ))}
              </div>
            </div>
          
          {/* Products submenu with accordion */}
          <div className={clsx(
            'pb-6 absolute inset-0 overflow-y-auto transition-transform duration-300 ease-in-out',
            activeSubmenu === 'navbar_products' ? 'translate-x-0' : 'translate-x-full'
          )}>
              <div className="flex flex-col gap-4">
                {/* MANAGE */}
                <div className={clsx(openAccordions['manage'] && "bg-[#161B85]")}>
                  <button
                    onClick={() => toggleAccordion('manage')}
                    className="w-full flex items-center justify-between py-3 border-b border-white/20 px-4"
                  >
                    <div className="flex flex-col items-start text-left">
                      <p className={clsx("text-xl font-black uppercase transition-colors", openAccordions['manage'] ? 'text-green-main' : 'text-white')}>
                        {t('nav_manage_title')}
                      </p>
                    </div>
                    {openAccordions['manage'] ? (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12H19" stroke="#00FF85" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5V19M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    )}
                  </button>
                  <div className={clsx(
                    "grid transition-all duration-300 ease-in-out",
                    openAccordions['manage'] ? "grid-rows-[1fr] opacity-100 mt-3" : "grid-rows-[0fr] opacity-0"
                  )}>
                    <div className="overflow-hidden">
                      <div className="flex flex-col gap-3 pb-3 pl-0.5 px-4">
                        <button
                          onClick={() => {
                            setIsOpen(false)
                            window.open('https://blog.freedom.world/', '_blank')
                          }}
                          className="flex items-center gap-2 text-white hover:text-green-main mb-2 group px-5"
                        >
                          <span className="text-sm font-bold uppercase">{t('nav_manage_explore_title')}</span>
                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M12.8454 6.66659L15.5895 9.41066C15.9149 9.7361 15.9149 10.2637 15.5895 10.5892L12.8454 13.3333M15.3454 9.99992L3.67871 9.99992" stroke="#F4F4FC" strokeWidth="1.5" strokeLinecap="round"/>
</svg>
                        </button>
                        {MANAGE_PRODUCTS.map((x) => (
                          <div key={x.label} className="px-5 cursor-pointer flex gap-3" onClick={() => {
                            setIsOpen(false)
                            window.open(x.url, '_blank')
                          }}>
                            <Image src={x.icon} width={24} height={24} alt="" className="shrink-0 h-6 w-6" />
                            <div>
                              <span className="text-sm font-semibold text-white block">{t(x.label)}</span>
                              <span className="text-xs text-white/80">{t(x.desc)}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* ENGAGE */}
                <div className={clsx(openAccordions['engage'] && "bg-[#161B85]")}>
                  <button
                    onClick={() => toggleAccordion('engage')}
                    className="w-full flex items-center justify-between py-3 border-b border-white/20 px-4"
                  >
                    <div className="flex flex-col items-start text-left">
                      <p className={clsx("text-xl font-black uppercase transition-colors", openAccordions['engage'] ? 'text-green-main' : 'text-white')}>
                        {t('products_engage_title')}
                      </p>
                    </div>
                    {openAccordions['engage'] ? (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12H19" stroke="#00FF85" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5V19M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    )}
                  </button>
                  <div className={clsx(
                    "grid transition-all duration-300 ease-in-out",
                    openAccordions['engage'] ? "grid-rows-[1fr] opacity-100 mt-3" : "grid-rows-[0fr] opacity-0"
                  )}>
                    <div className="overflow-hidden">
                      <div className="flex flex-col gap-3 pb-3 pl-0.5 px-4">
                        <button
                          onClick={() => {
                            setIsOpen(false)
                            window.open('https://blog.freedom.world/', '_blank')
                          }}
                          className="flex items-center gap-2 text-white hover:text-green-main mb-2 group px-5"
                        >
                          <span className="text-sm font-bold uppercase">{t('nav_engage_explore_title')}</span>
                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M12.8454 6.66659L15.5895 9.41066C15.9149 9.7361 15.9149 10.2637 15.5895 10.5892L12.8454 13.3333M15.3454 9.99992L3.67871 9.99992" stroke="#F4F4FC" strokeWidth="1.5" strokeLinecap="round"/>
</svg>
                        </button>
                        {ENGAGE_PRODUCTS.map((x) => (
                          <div key={x.label} className="px-5 cursor-pointer flex gap-3" onClick={() => {
                            setIsOpen(false)
                            window.open(x.url, '_blank')
                          }}>
                            <Image src={x.icon} width={24} height={24} alt="" className="shrink-0 h-6 w-6" />
                            <div >
                              <span className="text-sm font-semibold text-white cursor-pointer block">{t(x.label)}</span>
                              <span className="text-xs text-white/80">{t(x.desc)}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* MONETIZE */}
                <div className={clsx(openAccordions['monetize'] && "bg-[#161B85]")}>
                  <button
                    onClick={() => toggleAccordion('monetize')}
                    className="w-full flex items-center justify-between py-3 border-b border-white/20 px-4"
                  >
                    <div className="flex flex-col items-start text-left">
                      <p className={clsx("text-xl font-black uppercase transition-colors", openAccordions['monetize'] ? 'text-green-main' : 'text-white')}>
                        {t('products_monetize_title')}
                      </p>
                    </div>
                    {openAccordions['monetize'] ? (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12H19" stroke="#00FF85" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5V19M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    )}
                  </button>
                  <div className={clsx(
                    "grid transition-all duration-300 ease-in-out",
                    openAccordions['monetize'] ? "grid-rows-[1fr] opacity-100 mt-3" : "grid-rows-[0fr] opacity-0"
                  )}>
                    <div className="overflow-hidden">
                      <div className="flex flex-col gap-3 pb-3 pl-0.5 px-4">
                        <button
                          onClick={() => {
                            setIsOpen(false)
                            window.open('https://blog.freedom.world/', '_blank')
                          }}
                          className="flex items-center gap-2 text-white hover:text-green-main mb-2 group px-5"
                        >
                          <span className="text-sm font-bold uppercase">{t('nav_monetize_explore_title')}</span>
                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M12.8454 6.66659L15.5895 9.41066C15.9149 9.7361 15.9149 10.2637 15.5895 10.5892L12.8454 13.3333M15.3454 9.99992L3.67871 9.99992" stroke="#F4F4FC" strokeWidth="1.5" strokeLinecap="round"/>
</svg>
                        </button>
                        {MONETIZE_PRODUCTS.map((x) => (
                          <div key={x.label} className="px-5 cursor-pointer flex gap-3" onClick={() => {
                            setIsOpen(false)
                            window.open(x.url, '_blank')
                          }}>
                            <Image src={x.icon} width={24} height={24} alt="" className="shrink-0 h-6 w-6" />
                            <div>
                              <span className="text-sm font-semibold text-white block cursor-pointer">{t(x.label)}</span>
                              <span className="text-xs text-white/80">{t(x.desc)}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          
          {/* Solutions submenu with accordion */}
          <div className={clsx(
            'pb-6 absolute inset-0 overflow-y-auto transition-transform duration-300 ease-in-out',
            activeSubmenu === 'navbar_solutions' ? 'translate-x-0' : 'translate-x-full'
          )}>
              <div className="flex flex-col gap-4">
                {/* Businesses */}
                <div className={clsx(openAccordions['businesses'] && "bg-[#161B85]")}>
                  <button
                    onClick={() => toggleAccordion('businesses')}
                    className="w-full flex items-center justify-between py-3 border-b border-white/20 px-4"
                  >
                    <div className="flex flex-col items-start text-left">
                      <p className={clsx("text-xl font-black uppercase transition-colors", openAccordions['businesses'] ? 'text-green-main' : 'text-white')}>
                        {t('nav_businesses_title')}
                      </p>
                    </div>
                    {openAccordions['businesses'] ? (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12H19" stroke="#00FF85" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5V19M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    )}
                  </button>
                  <div className={clsx(
                    "grid transition-all duration-300 ease-in-out",
                    openAccordions['businesses'] ? "grid-rows-[1fr] opacity-100 mt-3" : "grid-rows-[0fr] opacity-0"
                  )}>
                    <div className="overflow-hidden">
                      <div className="flex flex-col gap-3 pb-3 pl-0.5 px-4">
                        <button
                          onClick={() => {
                            setIsOpen(false)
                            window.open('https://freedom.world/solutions/for-businesses', '_blank')
                          }}
                          className="flex items-center gap-2 text-white hover:text-green-main mb-2 group px-5"
                        >
                          <span className="text-sm font-bold uppercase">{t('nav_businesses_explore_title')}</span>
                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M12.8454 6.66659L15.5895 9.41066C15.9149 9.7361 15.9149 10.2637 15.5895 10.5892L12.8454 13.3333M15.3454 9.99992L3.67871 9.99992" stroke="#F4F4FC" strokeWidth="1.5" strokeLinecap="round"/>
</svg>
                        </button>
                        {[
                          { label: t('nav_solutions_acquire_customers_title'), desc: t('nav_solutions_acquire_customers_desc'), icon: '/svgs/icon_people.svg' },
                          { label: t('nav_solutions_build_loyalty_title'), desc: t('nav_solutions_build_loyalty_desc'), icon: '/svgs/icon_starbadge.svg' },
                          { label: t('nav_solutions_engage_community_title'), desc: t('nav_solutions_engage_community_desc'), icon: '/svgs/icon_community.svg' },
                          { label: t('nav_solutions_sell_monetize_title'), desc: t('nav_solutions_sell_monetize_desc'), icon: '/svgs/icon_dollar.svg' },
                          { label: t('nav_solutions_understand_customers_title'), desc: t('nav_solutions_understand_customers_desc'), icon: '/svgs/icon_analyze.svg' },
                        ].map((x) => (
                          <div key={x.label} className="flex gap-3 px-5">
                            <Image src={x.icon} width={24} height={24} alt="" className="shrink-0 h-6 w-6" />
                            <div>
                              <span className="text-sm font-semibold text-white block">{x.label}</span>
                              <span className="text-xs text-white/80">{x.desc}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Creators */}
                <div className={clsx(openAccordions['creators'] && "bg-[#161B85]")}>
                  <button
                    onClick={() => toggleAccordion('creators')}
                    className="w-full flex items-center justify-between py-3 border-b border-white/20 px-4"
                  >
                    <div className="flex flex-col items-start text-left">
                      <p className={clsx("text-xl font-black uppercase transition-colors", openAccordions['creators'] ? 'text-green-main' : 'text-white')}>
                        {t('nav_creators_title')}
                      </p>
                    </div>
                    {openAccordions['creators'] ? (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12H19" stroke="#0008ff" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5V19M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    )}
                  </button>
                  <div className={clsx(
                    "grid transition-all duration-300 ease-in-out",
                    openAccordions['creators'] ? "grid-rows-[1fr] opacity-100 mt-3" : "grid-rows-[0fr] opacity-0"
                  )}>
                    <div className="overflow-hidden">
                      <div className="flex flex-col gap-3 pb-3 pl-0.5 px-4">
                        <button
                          onClick={() => {
                            setIsOpen(false)
                            window.open('https://freedom.world/solutions/for-creators', '_blank')
                          }}
                          className="flex items-center gap-2 text-white hover:text-green-main mb-2 group px-5"
                        >
                          <span className="text-sm font-bold uppercase">{t('nav_creators_explore_title')}</span>
                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M12.8454 6.66659L15.5895 9.41066C15.9149 9.7361 15.9149 10.2637 15.5895 10.5892L12.8454 13.3333M15.3454 9.99992L3.67871 9.99992" stroke="#F4F4FC" strokeWidth="1.5" strokeLinecap="round"/>
</svg>
                        </button>
                        {[
                          { label: t('nav_solutions_own_audience_title'), desc: t('nav_solutions_own_audience_desc'), icon: '/svgs/icon_heartmessage.svg' },
                          { label: t('nav_solutions_monetize_content_title'), desc: t('nav_solutions_monetize_content_desc'), icon: '/svgs/icon_analyze.svg' },
                          { label: t('nav_solutions_engage_fans_title'), desc: t('nav_solutions_engage_fans_desc'), icon: '/svgs/icon_starbadge.svg' },
                          { label: t('nav_solutions_distribute_content_title'), desc: t('nav_solutions_distribute_content_desc'), icon: '/svgs/icon_dollar.svg' },
                          { label: t('nav_solutions_track_growth_title'), desc: t('nav_solutions_track_growth_desc'), icon: '/svgs/icon_people.svg' },
                        ].map((x) => (
                          <div key={x.label} className="flex gap-3 px-5">
                            <Image src={x.icon} width={24} height={24} alt="" className="shrink-0 h-6 w-6" />
                            <div>
                              <span className="text-sm font-semibold text-white block">{x.label}</span>
                              <span className="text-xs text-white/80">{x.desc}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Users */}
                <div className={clsx(openAccordions['users'] && "bg-[#161B85]")}>
                  <button
                    onClick={() => toggleAccordion('users')}
                    className="w-full flex items-center justify-between py-3 border-b border-white/20 px-4"
                  >
                    <div className="flex flex-col items-start text-left">
                      <p className={clsx("text-xl font-black uppercase transition-colors", openAccordions['users'] ? 'text-green-main' : 'text-white')}>
                        {t('nav_users_title')}
                      </p>
                    </div>
                    {openAccordions['users'] ? (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12H19" stroke="#00FF85" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5V19M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    )}
                  </button>
                  <div className={clsx(
                    "grid transition-all duration-300 ease-in-out",
                    openAccordions['users'] ? "grid-rows-[1fr] opacity-100 mt-3" : "grid-rows-[0fr] opacity-0"
                  )}>
                    <div className="overflow-hidden">
                      <div className="flex flex-col gap-3 pb-3 pl-0.5 px-4">
                        <button
                          onClick={() => {
                            setIsOpen(false)
                            window.open('https://freedom.world/solutions/for-users', '_blank')
                          }}
                          className="flex items-center gap-2 text-white hover:text-green-main mb-2 group px-5"
                        >
                          <span className="text-sm font-bold uppercase">{t('nav_users_explore_title')}</span>
                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M12.8454 6.66659L15.5895 9.41066C15.9149 9.7361 15.9149 10.2637 15.5895 10.5892L12.8454 13.3333M15.3454 9.99992L3.67871 9.99992" stroke="#F4F4FC" strokeWidth="1.5" strokeLinecap="round"/>
</svg>
                        </button>
                        {[
                         {
                                label: t(
                                  'nav_solutions_discover_experience_title',
                                ),
                                desc: t(
                                  'nav_solutions_discover_experience_desc',
                                ),
                                icon: '/svgs/icon_compass.svg',
                              },
                              {
                                label: t('nav_solutions_connect_belong_title'),
                                desc: t('nav_solutions_connect_belong_desc'),
                                icon: '/svgs/icon_community.svg',
                              },{
                                label: t(
                                  'nav_solutions_explore_and_play_title',
                                ),
                                desc: t('nav_solutions_explore_and_play_desc'),
                                icon: '/svgs/icon_game.svg',
                              },
                              {
                                label: t(
                                  'nav_solutions_collect_manage_rewards_title',
                                ),
                                desc: t(
                                  'nav_solutions_collect_manage_rewards_desc',
                                ),
                                icon: '/svgs/mingcute_wallet-fill.svg',
                              },
                              {
                                label: t(
                                  'nav_solutions_express_identity_title',
                                ),
                                desc: t('nav_solutions_express_identity_desc'),
                                icon: '/svgs/icon_fingerprint.svg',
                              },
                        ].map((x) => (
                          <div key={x.label} className="flex gap-3 px-5">
                            <Image src={x.icon} width={24} height={24} alt="" className="shrink-0 h-6 w-6" />
                            <div>
                              <span className="text-sm font-semibold text-white block">{x.label}</span>
                              <span className="text-xs text-white/80">{x.desc}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>

          {/* Bottom section with language switcher and buttons - only show on main menu */}
          {!activeSubmenu && (
            <div className="flex items-center justify-center gap-3 mt-auto pt-6 px-6 shrink-0 bg-[#161B85] [&_span]:text-xs! [&_span]:whitespace-nowrap [&_button>div]:justify-center! [&_a>div]:justify-center! [&_button>div]:py-1! [&_button>div]:px-3! [&_a>div]:py-1! [&_a>div]:px-3! pb-6">
              <LanguageSwitcher />
              <MainButton
                label={t('navbar_bookademo')}
                href={'https://freedom.world/community-features/request-demo'}
                target="_blank"
                 
              />
              <MainButton
                label={t('navbar_download')}
                onClick={handleDownloadClick}
              />
            </div>
          )}
      </div>
    </div>
  )
}

const Header = () => {
  const t = useT()
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [isDownloadOpen, setIsDownloadOpen] = useState<boolean>(false)

  // Prevent horizontal page shift and background scrolling
  useEffect(() => {
    if (isOpen) {
      // Store current scroll position
      const scrollY = window.scrollY
      
      // Prevent all scrolling when menu is open
      document.documentElement.style.overflow = 'hidden'
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      document.body.style.top = `-${scrollY}px`
      document.body.style.width = '100%'
    } else {
      // Restore scroll position
      const scrollY = document.body.style.top
      document.documentElement.style.overflow = ''
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0') * -1)
      }
      
      // Only prevent horizontal scrolling when menu is closed
      document.body.style.overflowX = 'hidden'
    }

    return () => {
      document.documentElement.style.overflow = ''
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      document.body.style.overflowX = ''
    }
  }, [isOpen])

  const menuRef = useRef<HTMLDivElement>(null)
  const buttonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      if (
        menuRef.current &&
        !menuRef.current.contains(target) &&
        buttonRef.current &&
        !buttonRef.current.contains(target)
      ) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  return (
    <div className="sticky top-0 z-100 ">
      <div className="sticky top-0 px-4  flex justify-between gap-4 w-full z-50 backdrop-blur-md bg-main-bg h-27.25">
        <div className="flex max-w-360 justify-between items-center m-auto w-full">
          <div className="flex">
            <Link href="/" className="text-xl font-bold text-gray-800">
              <Image
                src="/svgs/freedom-logo.svg"
                alt="Freedom Logo"
                width={188}
                height={60}
              />
            </Link>

            <nav className="hidden md:flex ">
              <div className="max-w-7xl mx-auto flex items-center justify-between">
                <div className="flex gap-4 z-0">
                  {navItems.map((item, i) =>
                    item.children ? (
                      <DesktopNavItemHoverIntent
                        key={item.name + i}
                        item={item}
                        t={t}
                      />
                    ) : (
                      <button
                        key={item.name}
                        onClick={() => {
                          if (
                            item.href === 'Journey' ||
                            item.href === 'Communities'
                          ) {
                            const el = document.getElementById(item.href)
                            if (el) el.scrollIntoView({ behavior: 'smooth' })
                          } else {
                            window.open(item.href, '_blank')
                          }
                        }}
                        className={clsx(
                          'hover:cursor-pointer text-white/90 hover:text-green-main whitespace-nowrap text-xs font-bold uppercase cursor-pointer h-full',
                          padding('Button/Spacing/left-right'),
                          padding('Button/Spacing/top-bot'),
                        )}
                      >
                        <Typography
                          variant="buttonSmall"
                          type="span"
                          weight="400"
                          className="w-fit text-white hover:cursor-pointer"
                        >
                          {t(item.name)}
                        </Typography>
                      </button>
                    ),
                  )}
                </div>
              </div>
            </nav>
          </div>
          <div className="hidden md:flex gap-3 justify-center items-center">
            {/* <a
              className="px-4 py-3 rounded-4xl border-2 whitespace-nowrap text-green-main  text-sm font-bold uppercase cursor-pointer"
              href="https://freedom.world/freedom"
              target="_blank"
            >
              <Typography
                variant="bodyXSmall"
                type="span"
                weight="900"
                className="w-fit text-green-main uppercase  text-sm"
              >
                {t('footer_get_started_join_a_community')}
              </Typography>
            </a>
            <CustomButton
              title={t('header_create_commu')}
              typographyVariant="bodyXSmall"
              circleColor="bg-white"
              fontSize="text-xs"
              onClickUrl="https://console.freedom.world/"
              className="uppercase"
            /> */}
            <div className="hidden md:flex gap-3 justify-center items-center">
              {/* <DownloadButtonHeader /> */}
              <MainButton
                label={t('navbar_bookademo')}
                href={'https://freedom.world/community-features/request-demo'}
                target="_blank"
              />
              <div className="relative">
                <MainButton
                  label={t('navbar_download')}
                  onClick={() => setIsDownloadOpen((prev) => !prev)}
                />
                <DownloadQrModal
                  open={isDownloadOpen}
                  onOpenChange={setIsDownloadOpen}
                  title={t('popup_getstarted_download_title')}
                  description={t('popup_getstarted_download_desc')}
                />
              </div>
              <LanguageSwitcher />
            </div>
          </div>
          <button
            ref={buttonRef}
            className="flex md:hidden cursor-pointer z-50"
            onClick={() => {
              setIsOpen(!isOpen)
            }}
          >
            <Image
              src={isOpen ? '/svgs/Cross.svg' : '/svgs/menu.svg'}
              alt={isOpen ? 'Close menu' : 'Open menu'}
              width={34}
              height={34}
            />
          </button>
        </div>
      </div>
      <RenderHamburger
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        menuRef={menuRef}
      />
    </div>
  )
}

export default Header
